import { ApiFilter } from 'module/ui/components/molecules/field-filter/simple-search-filter/simple-search-filter';
import { isEmpty } from 'lodash';
import { stringify } from 'query-string';
import { HttpClient } from '../http-client';
import {
  Company,
  CustomerCompany,
  CustomerCompanyListFilter,
  PaginatedCustomerCompaniesParams,
  PaginatedCustomerCompaniesResponse,
  UpdateCustomerCompanyPayload,
} from './types';

const filterToQueryString = (filter: CustomerCompanyListFilter): string => {
  const criteriaQuery = ApiFilter.toQueryStringFormat(filter.criteria);

  if (criteriaQuery.length) {
    return `${criteriaQuery}&${stringify(
      { match: criteriaQuery.length ? filter.type : null },
      { skipNull: true, skipEmptyString: true },
    )}`;
  }

  return '';
};
//&company*companyName.contains=${searchText}
const searchTextToQueryString = (searchText: string) =>
  isEmpty(searchText) ? '' : `&company*companyName.contains=${searchText}`;

const searchAndFilterToQueryString = (
  filter: CustomerCompanyListFilter,
  searchText: string,
): string => filterToQueryString(filter) + searchTextToQueryString(searchText);

export class CompanyClient extends HttpClient {
  public getCompanyById = (companyId: number): Promise<Company> => {
    return this.get<Company>(`/companies/${companyId}/customer-portfolio`);
  };
  public getCustomerCompanies = (): Promise<Company[]> => {
    return this.get<Company[]>('/companies').then((x) =>
      x.filter((x) => x.companyType === 'CUSTOMER'),
    );
  };
  public getPaginatedCompanies = async ({
    filter,
    searchText,
    sort,
    startRow,
    endRow,
  }: PaginatedCustomerCompaniesParams): Promise<PaginatedCustomerCompaniesResponse> => {
    const queryString = searchAndFilterToQueryString(filter, searchText);

    return this.get<PaginatedCustomerCompaniesResponse>(
      `/scarlet/company/list${queryString ? `?${queryString}` : ''}`,
      {
        params: {
          sort,
          offset: startRow,
          limit: endRow - startRow,
        },
      },
    );
  };
  public updateCompany = (
    companyId: number,
    payload: UpdateCustomerCompanyPayload,
  ): Promise<CustomerCompany> => {
    return this.put(`/companies/${companyId}`, payload);
  };
}
